import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useRef, useState } from 'react';
import lodashDebounce from 'lodash/debounce';
export function useDebouncedChange(onChangeProp) {
  var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDebounced = _useState2[0],
      setIsDebounced = _useState2[1];

  var onChangeRef = useRef(onChangeProp);
  onChangeRef.current = onChangeProp;
  var debouncedUpdate = useRef(lodashDebounce(function (value) {
    onChangeRef.current(value);
    setIsDebounced(false);
  }, debounce));
  var onChange = useCallback(function (value) {
    if (value) {
      setIsDebounced(true);
      debouncedUpdate.current(value);
    } else {
      setIsDebounced(false);
      debouncedUpdate.current.cancel();
      window.requestAnimationFrame(function () {
        onChangeRef.current(value);
      });
    }
  }, []);
  return {
    isDebounced: isDebounced,
    onChange: onChange
  };
}